const previewerNavigationReducerDefaultState = {
    isDrawerOpen: false,
    showNavigationLayout: false
};

export default (state = previewerNavigationReducerDefaultState, action) => {
    switch (action.type) {
        case "SET_DRAWER_STATE":
            return {
                ...state,
                isDrawerOpen: action.payload
            };
        case "SET_SHOW_NAVIGATION_LAYOUT":
            return {
                ...state,
                showNavigationLayout: action.payload
            };
        default:
            return state;
    }
};
  